import React from "react";

const Deposits = () => {
  return (
    <div className="shadow-md shadow-tableColor mt-5 overflow-hidden rounded-lg">
      <div className="w-full flex justify-between items-center bg-tableColor rounded-t-md rounded-r-md px-5 py-4">
        <div className="text-bodyColor text-lg font-Inter font-bold break-words">
          Deposits
        </div>
        <div className="text-bodyColor text-lg font-Inter font-bold break-words">
          $11.22
        </div>
      </div>
      <div className="flex justify-between px-5 py-4 bg-tableBodyColor">
        <div className="flex items-center">
          <div className="rounded-full bg-tableColor w-10 h-10"></div>
          <div className="inline-block ml-2">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              BTC
            </div>
            <div className="text-opaBodyColor text-sm font-Inter font-semibold break-words mt-1">
              $0.999959
            </div>
          </div>
        </div>
        <div>
          <div className="inline-block ml-2">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              11.22 BTC
            </div>
            <div className="text-opaBodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
              $11.22
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deposits;
